import React, { useState, useEffect } from "react";
import {
    Box,
    List,
    ListItem,
    ListItemText,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
} from "@mui/material";
import { Add, Edit, Delete } from "@mui/icons-material";
import ConfirmationDialog from "./ConfirmationDialog";

const StickyNotesComponent = ({ height = 300 }) => {
    const [openDialog, setOpenDialog] = useState(false);
    const [currentNote, setCurrentNote] = useState("");
    const [editIndex, setEditIndex] = useState(null);
    const [confirmDelete, setConfirmDelete] = useState({ open: false, index: null });

    const [notes, setNotes] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("stickyNotes")) || [];
        } catch {
            return [];
        }
    });

    // Save notes to localStorage whenever notes change
    useEffect(() => {
        localStorage.setItem("stickyNotes", JSON.stringify(notes));
    }, [notes]);

    const handleAddClick = () => {
        setEditIndex(null);
        setCurrentNote("");
        setOpenDialog(true);
    };

    const handleEditClick = (index) => {
        setEditIndex(index);
        setCurrentNote(notes[index]);
        setOpenDialog(true);
    };

    const handleDeleteClick = (index) => {
        setConfirmDelete({ open: true, index });
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
        setCurrentNote("");
        setEditIndex(null);
    };

    const handleConfirmDelete = () => {
        const updatedNotes = [...notes];
        updatedNotes.splice(confirmDelete.index, 1);
        setNotes(updatedNotes);
        setConfirmDelete({ open: false, index: null });
    };

    const handleDialogSave = () => {
        if (currentNote.trim() === "") return;

        let updatedNotes = [...notes];
        if (editIndex !== null) {
            updatedNotes[editIndex] = currentNote;
        } else {
            updatedNotes.push(currentNote);
        }
        setNotes(updatedNotes);
        handleDialogClose();
    };

    return (
        <Box
            sx={{
                paddingLeft: '8px',
                paddingRight: '8px',
                height: height,
                display: "flex",
                flexDirection: "column",
                borderRadius: 2,
                backgroundColor: "#fff",
            }}
        >
            {/* Header with Plus Icon */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                <Typography variant='h6' sx={{ fontWeight: 'bold', color: '#3d3d3d', padding: '4px 0' }}>Notes / Remarks</Typography>
                <IconButton color="primary" onClick={handleAddClick}>
                    <Add />
                </IconButton>
            </Box>

            {/* Scrollable Notes List */}
            <Box sx={{ overflowY: "auto", flexGrow: 1 }}>
                <List sx={{ paddingTop: '0px' }}>
                    {notes.map((note, index) => (
                        <ListItem
                            key={index}
                            sx={{
                                backgroundColor: "#fffae6",
                                marginTop: '6px',
                                borderRadius: 1,
                                boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: '4px 6px'

                            }}
                        >
                            <ListItemText primary={note} sx={{ flex: 1 }} />
                            <Box>
                                <IconButton
                                    size="small"
                                    // color="primary"
                                    onClick={() => handleEditClick(index)}
                                >
                                    <Edit fontSize="small" />
                                </IconButton>
                                <IconButton
                                    size="small"
                                    // color="primary"
                                    onClick={() => handleDeleteClick(index)}
                                >
                                    <Delete fontSize="small" />
                                </IconButton>
                            </Box>
                        </ListItem>
                    ))}
                </List>
            </Box>

            {/* Add/Edit Note Dialog */}
            <Dialog open={openDialog} onClose={handleDialogClose} maxWidth="sm" fullWidth>
                <DialogTitle>{editIndex !== null ? "Edit Note" : "Add Note"}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Note"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={currentNote}
                        onChange={(e) => setCurrentNote(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>Cancel</Button>
                    <Button onClick={handleDialogSave} variant="contained" color="primary">
                        {editIndex !== null ? "Save" : "Add"}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Confirm Delete Dialog */}
            <ConfirmationDialog
                open={confirmDelete.open}
                onClose={() => setConfirmDelete({ open: false, index: null })}
                onConfirm={handleConfirmDelete}
                message="Are you sure you want to delete this note?"
            />
        </Box>
    );
};

export default StickyNotesComponent;
